import { useWebSocket } from "@/providers/WebSocketProvider";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function OnlineAdmins() {
  const { onlineAdmins } = useWebSocket();

  // Show all online admins
  const othersOnline = onlineAdmins;

  if (othersOnline.length === 0) {
    return null;
  }

  // Show up to 5 admins
  const displayAdmins = othersOnline.slice(0, 5);
  const remainingCount = othersOnline.length - 5;

  return (
    <div className="flex items-center -space-x-2 mr-4">
      <TooltipProvider delayDuration={0}>
        {displayAdmins.map((admin) => (
          <Tooltip key={admin.id}>
            <TooltipTrigger asChild>
              <Avatar className="h-8 w-8 border-2 border-background ring-1 ring-border/50 transition-transform hover:z-10 hover:scale-110 cursor-default">
                <AvatarImage
                  src={admin.photoUrl || undefined}
                  alt={admin.firstName || admin.email}
                />
                <AvatarFallback className="bg-primary/10 text-primary text-xs font-medium">
                  {admin.firstName
                    ? admin.firstName.substring(0, 2).toUpperCase()
                    : admin.email.substring(0, 2).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {admin.firstName && admin.lastName
                  ? `${admin.firstName} ${admin.lastName}`
                  : admin.email}
              </p>
              <p className="text-xs text-muted-foreground">Online</p>
            </TooltipContent>
          </Tooltip>
        ))}
        {remainingCount > 0 && (
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-background bg-muted ring-1 ring-border/50 text-xs font-medium">
            +{remainingCount}
          </div>
        )}
      </TooltipProvider>
    </div>
  );
}
